import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { LangProvider } from "./context/LangContext";
import { AuthProvider } from "./context/AuthContext";
import App from "./App";
import "./styles.css";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <LangProvider>
      <AuthProvider>
        <App />
      </AuthProvider>
    </LangProvider>
  </StrictMode>
);
